// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7467":"01905d89db1a1c4e","7981":"23aee61ca2bb5db8"}[chunkId] + ".css";
};